<template>
    <tr
        class="z-table-row"
        :class="buildClass"
        @click="check"
    >
        <slot />
    </tr>
    <slot name="row" v-if="opened" /> <!-- для z-table-row с элементами раскрытия-->
</template>

<script setup>
import {computed, ref} from 'vue'

const props = defineProps({
    name: {
        type: String,
        default: ''
    },
    isClickable: {
        type: Boolean
    },
    isExpandable: {
        type: Boolean
    } // пропс для добавления z-table-row стилей раскрытия
})

const opened = ref(false)
const clicked = ref(false)

const buildClass = computed(() => {
    return {
        'is-opened': clicked.value,
        'z-table-row--clickable': props.isClickable,
        'z-table-row--expandable': props.isExpandable
    }
})

const check = () => {
    if (props.isClickable) {
        clicked.value = !clicked.value
        opened.value = !opened.value
    }
}

defineExpose({
    props
})
</script>
